export const FirebaseConfig = {
    apiKey: "AIzaSyAXR_F5PI_05rz1lNVHYvcjsyFpRCcPoGc",
    authDomain: "towards-sdg.firebaseapp.com",
    databaseURL: "https://towards-sdg.firebaseio.com",
    projectId: "towards-sdg",
    storageBucket: "towards-sdg.appspot.com",
    messagingSenderId: "431265797823",
    appId: "1:431265797823:web:3fdea673ce1dc9195f980a"
};
